import { Outlet } from "react-router-dom";

import { Flexbox } from "@src/shared/components/layout/Flexbox";

import type { SettingsLayoutV2Props } from "./SettingsLayout.types";
import { SettingsSidebar } from "./SettingsSidebar";

export function SettingsLayoutV2({ children }: SettingsLayoutV2Props) {
  return (
    <Flexbox className="min-h-full flex-col md-stitch:flex-row">
      <SettingsSidebar />
      <Flexbox className="min-w-0 flex-1">{children ?? <Outlet />}</Flexbox>
    </Flexbox>
  );
}
